export var REDUCERS = {
  SET_VALUE: "set_value",
  SET_DROPDOWN_ITEMS: "set_dropdown_items"
};